// @flow

import moment from 'moment/moment'
import type { Price } from './price'
import { PaymentLine } from './payment-line'
import type { OrderItem } from './order-item'

export type CartItem = {
  orderItemId: string,
  productTitle: string,
  engravedId: ?string,
  dateEffective: moment,
  vatPercentage: string,
  vatAmount: Price,
  amountWithVat: Price,
  amountWithoutVat: Price,
  discountAmount: Price,
  totalAmountWithVat: Price,
  combiDealDiscountAmount: Price,
  directPayment: ?PaymentLine,
  termPayments: PaymentLine[],
  nrOfTerms: ?number
}

const buildCartItem = function (key: string, orderItem: OrderItem): CartItem {
  return {
    orderItemId: key,
    productTitle: orderItem.title,
    engravedId: orderItem.engravedId,
    dateEffective: orderItem.startDate ? moment(orderItem.startDate) : '',
    vatPercentage: '',
    vatAmount: { amount: 0, currency: 'EUR' },
    amountWithVat: { amount: 0, currency: 'EUR' },
    amountWithoutVat: { amount: 0, currency: 'EUR' },
    discountAmount: { amount: 0, currency: 'EUR' },
    totalAmountWithVat: { amount: 0, currency: 'EUR' },
    combiDealDiscountAmount: { amount: 0, currency: 'EUR' },
    directPayment: null,
    termPayments: [],
    nrOfTerms: orderItem.nrOfTerms
  }
}

export {
  buildCartItem
}



// WEBPACK FOOTER //
// ./src/types/cart-item.js